<template>
  <div>
    <CardCadastro>
      <div slot="header">
        <h4
          class="title"
          v-if="pg_item != undefined && pg_item.categoria_nome != undefined"
        >{{pg_item.categoria_nome}}</h4>
      </div>
      <div slot="body">
        <div class="md-layout" v-if="show_message == 'on' ">
          <div class="alert alert-success" style="width: 100%">{{message_text}}</div>
        </div>

        <div v-if="loading">
          <md-progress-spinner :md-diameter="30" md-mode="indeterminate"></md-progress-spinner>

          {{msg_status}} ..
        </div>

        <table class="striped responsive-table edit-table">
          <thead>
            <tr>
              <th>Ordem</th>
              <th>Item</th>
              <th style="width: 30px"></th>

              <th v-if="false">
                <md-button class="md-just-icon md-info md-simple" @click.native="add">
                  <md-icon>add</md-icon>
                </md-button>
              </th>
            </tr>
          </thead>
          <tbody v-if="pg_item != undefined && pg_item.itens != undefined">
            <tr v-for="(item, index) in pg_item.itens" :key="index">
              <td>
                <input
                  type="text"
                  v-model="item.ordem"
                  v-on:change="change_value"
                  class="form-control"
                  v-bind:id="getIDItem('ordem', index)"
                />
              </td>
              <td>{{item.item_nome}}</td>
              <td>
                <checkbox_int v-model="item.entra" class_name="green" v-on:change="change_value"></checkbox_int>
                <switch_int v-model="item.entra" v-if="false" v-on:change="change_value"></switch_int>
                <!-- class_name="md-primary" -->
              </td>
              <td v-if="false">
                <md-button
                  class="md-just-icon md-info md-simple"
                  @click.native="excluir(item, index)"
                >
                  <md-icon>remove_circle</md-icon>
                </md-button>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr
              v-if="pg_item != undefined && pg_item.itens != undefined && pg_item.itens.length <= 0"
            >
              <td colspan="3">
                <i>Não há itens nessa categoria</i>
              </td>
            </tr>
            <tr style="display:none">
              <td colspan="3">
                <md-button
                  class="md-info pull-right"
                  type="button"
                  v-bind:disabled="disableButton"
                  v-on:click="salvar"
                >Salvar</md-button>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </CardCadastro>
  </div>
</template>

<script>
import service from "../../../services/ModeloChecklistItensService";
import serviceModelo from "../../../services/ModeloChecklistService";

import CardCadastro from "../../../components/CardCadastro";
import checkbox_int from "../../../components/Rend/checkbox_int";
import switch_int from "../../../components/Rend/switch_int";

export default {
  props: ["prop_item", "index"],
  model: {
    prop: "prop_item",
    event: "change"
  },
  watch: {
    prop_item(val) {
      if (this.index != null && this.prop_item != undefined) {
        this.pg_item = this.prop_item[this.index];
      }
    }
  },
  components: {
    CardCadastro,
    checkbox_int,
    switch_int
  },
  data: function() {
    return {
      pg_item: null,
      items: [],

      ids_excluir: [],

      action: "list",
      id: "",
      table: null,
      filtro_titulo: "",
      filtro_status: "",

      show_new_button: true,

      loading: false,
      msg_status: "Carregando",
      disableButton: false,

      pode_reload_qtde: false,

      message_text: "",
      show_message: "off",

      button_new_text: "" //<i class=\"fa fa-file\" ></i> NOVA POST"
    };
  },
  methods: {
    getIDItem(nome, index) {
      return "itens_" + nome + "_L" + index.toString();
    },
    change_data_item(id_campo, value) {
      if (id_campo.indexOf("data") > -1 && false) {
        var ar = id_campo.split("_L");
        var index = ar[1];
        var item = this.items[parseInt(index)];

        var arcampo = id_campo.split("itens_");
        var arcampo2 = arcampo[1].split("_L");
        var nome_campo = arcampo2[0];

        //console.log("Localizado nome do campo " + nome_campo + " e data"+ value);

        item[nome_campo] = value;
        Vue.set(this.items, parseInt(index), item);
        console.log("Consegui alterar para o indice : " + index);
      }
    },
    change_value(event) {
      if (event.target != null && event.target != undefined) {
        this.change_data_item(event.target.id, event.target.value);
      }

      if (this.pode_reload_qtde) {
        if (event == true || event == false) {
          //É um campo de checklist.
          var filt = this.pg_item.itens.filter(function(item) {
            return item.entra == 1;
          });

          if (
            this.pg_item.itens_qtde == null ||
            this.pg_item.itens_qtde == undefined
          ) {
            this.pg_item.itens_qtde = Array();
          }

          if (this.pg_item.itens_qtde.length == 0) {
            this.pg_item.itens_qtde[0] = { entra: 1, qtde: 0 };
          }

          if (
            this.pg_item != undefined &&
            this.pg_item.itens_qtde != undefined &&
            this.pg_item.itens_qtde[0] != undefined &&
            this.pg_item.itens_qtde[0] != null
          ) {
            this.pg_item.itens_qtde[0].qtde = filt.length;

            if (this.pg_item.itens_qtde[1] != undefined)
              this.pg_item.itens_qtde[1].qtde =
                this.pg_item.itens.length - filt.length;
          }
        }
      }

      // this.$emit("change");
    },
    excluir(item, index) {
      console.log("Excluir? ");

      if (item.id != null && item.id != "") {
        this.ids_excluir.unshift(item.id);
      }

      this.items.splice(index, 1);
    },

    salvar() {
      var self = this;
      var hd_json = JSON.stringify(this.items);
      var ids_delete_json = JSON.stringify(this.ids_excluir);

      if (this.onPreSave != null && this.onPreSave != undefined) {
        this.onPreSave(this.tabela, this.id_pai);
      }

      self.disableButton = true;
      self.loading = true;
      self.msg_status = "Salvando";

      service
        .salvarGrid(hd_json, ids_delete_json, this.tabela, this.id_pai)
        .then(function(response) {
          self.disableButton = false;
          self.loading = false;
          self.msg_status = "Carregando";
          self.show_message = "on";
          self.message_text = "Contatos salvos com sucesso!";

          if (self.onSave != null && self.onSave != undefined) {
            self.onSave(self.tabela, self.id_pai, self.items);
          }
        })
        .catch(function(error) {
          console.log(JSON.parse(JSON.stringify(error)));
        });
    },
    add() {
      this.items.push(this.getArrayItem());
    },
    loadData() {
      var self = this;

      this.disableButton = true;
      this.msg_status = "Carregando";

      var data = {};

      if (this.prop_item != null && this.prop_item != undefined) {
        // this.pg_item =this.prop_item;
        this.pg_item = this.prop_item[this.index];
      }

      if (this.pg_item == null || this.pg_item == undefined) {
        return false;
      }

      if (this.pg_item.id == null || this.pg_item.id == undefined) {
        console.log("cheguei aqui?  aaa ");

        if (
          this.pg_item.itens == null ||
          this.pg_item.itens == undefined ||
          this.pg_item.itens.length <= 0
        ) {
          this.loading = true;
          serviceModelo
            .getListItensVazio(this.pg_item.id_categoria)
            .then(function(response) {
              console.log("cheguei aqui? ");
              console.log(response.data);

              self.pg_item.itens = response.data;
              self.disableButton = false;
              self.loading = false;
              self.msg_status = "Carregando";
              self.pode_reload_qtde = true;
              // self.$emit("change");
            })
            .catch(function(error) {
              console.log(JSON.parse(JSON.stringify(error)));
            });
        }
      } else {
        self.pode_reload_qtde = true;
      }
    },
    getArrayItem() {
      var data = service.getModel();

      if (this.tabela != null) {
        data["tabela"] = this.tabela;
      }
      if (this.id_pai != null) {
        data["id_pai"] = this.id_pai;
      }

      return data;
    }
  },
  mounted() {
    let self = this;

    this.loadData();
  }
};
</script>